// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2vsZ_","range":"MonthRangeSwitch_range__1DP5F","disabled":"MonthRangeSwitch_disabled__1X1Xi"};